import { useSelector } from 'react-redux'
import { setMapEventPopin } from '../../../store/map/map.actions'
import { MAP_STATUS_STYLED } from '../../../store/map/map.constants'
import {
  selectActiveMapEvents,
  selectMapStatus,
  selectShouldDisplayMapEventPopin
} from '../../../store/map/map.selectors'
import { useAction } from '../../utils/react-redux'
import useErrorBoundaryCallback from '../../utils/useErrorBoundaryCallback'
import { useEffectWithMapContext } from '../MapContext'

const useClickMapEventsHandler = () => {
  const status = useSelector(selectMapStatus)
  const exectSetPopin = useAction(setMapEventPopin)
  const activeMapEvents = useSelector(selectActiveMapEvents)
  const shouldDisplayMapEventPopin = useSelector(selectShouldDisplayMapEventPopin)

  const handleClick = useErrorBoundaryCallback(e => {
    if (e.handled) return
    e.handled = true
    const feature = e?.features?.[0]
    if (feature) {
      exectSetPopin(feature.properties)
    }
  })

  useEffectWithMapContext(
    map => {
      if (!map.getStyle() || status !== MAP_STATUS_STYLED || !shouldDisplayMapEventPopin) return

      map
        .getStyle()
        .layers.filter(layer => layer.layout)
        .forEach(({ id }) => {
          activeMapEvents.forEach(mapEvent => {
            if (id.includes(mapEvent.key)) {
              map.on('click', id, handleClick)
            }
          })
        })

      return () => {
        if (map.getStyle()) {
          map
            .getStyle()
            .layers.filter(layer => layer.layout)
            .forEach(({ id }) => {
              map.off('click', id, handleClick)
            })
        }
      }
    },
    [status, shouldDisplayMapEventPopin]
  )
}

export default useClickMapEventsHandler
